import React from "react";
import { Col, Row } from "../framework/Grid";
import AcquireWebComponent from "../framework/MaterialUI";
import Dialog from "material-ui/Dialog";

const supportContainerStyle = {
  margin: "0px",
  fontWeight: "400",
  fontSize: "16px",
  padding: "0px",
  overflowY: "hidden",
  position: "relative",
};

const tableHead = {
  display: "inline-flex",
  background: "#273347",
  color: "#FFF",
  width: "100%",
  padding: "10px",
  borderTop: "solid 1px #EEEFF2",
  borderBottom: "solid 1px #EEEFF2",
  lineHeight: "10px",
  fontWeight: "bold",
};
const tableBodyRow = {
  display: "inline-flex",
  background: "#FFF",
  width: "100%",
  padding: "10px",
};

const basicTierCell = {
  width: "26%",
  textAlign: "center",
  borderLeft: "solid 1px #9C9FA4",
  borderRight: "solid 1px #9C9FA4",
};

const rowFirstCell = {
  width: "15%",
  background: "#9C9FA4",
  color: "#FFF",
  textAlign: "center",
  fontWeight: "bold",
  verticalAlign: "middle",
};
class ReleaseNote extends AcquireWebComponent {
  componentWillMount() {
    this.state = {
      collapsed: true,
      showTierInfoDialog: false,
    };
  }

  clickReadMore(e) {
    e.preventDefault();

    if (this.state.collapsed === true)
      this.setState({
        collapsed: false,
      });
    else
      this.setState({
        collapsed: true,
      });
  }

  showTierClick(e) {
    this.setState({
      showTierInfoDialog: true,
    });
  }

  hideTierClick(e) {
    e.preventDefault();
    this.setState({
      showTierInfoDialog: false,
    });
  }

  render() {
    const actions = [
      <a
        className="btn btn-claritas-default"
        onClick={this.hideTierClick.bind(this)}
      >
        Close
      </a>,
    ];
    return (
      <div style={{ ...supportContainerStyle, background: "#fff" }}>
        <Dialog
          open={this.state.showTierInfoDialog}
          autoScrollBodyContent={true}
          contentStyle={{ width: "640px", maxWidth: "1024px" }}
          bodyStyle={{ border: "none", color: "#000", fontSize: "16px" }}
          style={{ zIndex: "1600", paddingRight: "5%" }}
          actions={actions}
          actionsContainerStyle={{
            border: "none",
            textAlign: "right",
            marginTop: "-20px",
            padding: "20px",
          }}
        >
          <div style={{ fontSize: "16px" }} className="mb-10">
            <strong>SUBSCRIPTION TIERS</strong>
          </div>
          <div style={{ marginTop: "-5px", marginBottom: "10px" }}>
            <a href="mailto:AudienceAnywhere@claritas.com">Contact support</a>{" "}
            for pricing information
          </div>
          <div style={tableHead}>
            <div style={{ width: "15%" }} />
            <div style={{ width: "40%" }} />
            <div style={{ width: "23%", textAlign: "center" }}>Basic</div>
            <div style={{ width: "32%", textAlign: "center" }}>Standard</div>
          </div>
          <div style={{ ...tableBodyRow, padding: "0" }}>
            <div style={rowFirstCell}>
              <div style={{ marginTop: "25px" }}>Audience</div>
            </div>
            <div
              style={{ width: "85%", display: "inline-flex", flexWrap: "wrap" }}
            >
              <div
                style={{ width: "40%", fontWeight: "bold" }}
                className="p-10 bg-aa-grey"
              >
                Quick Counts
              </div>
              <div style={basicTierCell} className="p-10 bg-aa-grey">
                <i className="icon-checkmark4 text-teal-400 " />
              </div>
              <div
                style={{ width: "34%", textAlign: "center" }}
                className="p-10 bg-aa-grey"
              >
                <i className="icon-checkmark4 text-teal-400 " />
              </div>
              <div
                style={{ width: "40%", fontWeight: "bold" }}
                className="p-10"
              >
                Saved Segments Allowed
              </div>
              <div style={basicTierCell} className="p-10">
                Up to 10
              </div>
              <div
                style={{ width: "34%", textAlign: "center" }}
                className="p-10"
              >
                Unlimited
              </div>
            </div>
          </div>
          <div
            style={{
              ...tableBodyRow,
              padding: "0",
              borderTop: "solid 1px #FFF",
              borderBottom: "solid 1px #FFF",
            }}
          >
            <div style={rowFirstCell}>
              <div style={{ marginTop: "30px" }}>Campaigns</div>
            </div>
            <div
              style={{ width: "85%", display: "inline-flex", flexWrap: "wrap" }}
            >
              <div
                style={{ width: "40%", fontWeight: "bold" }}
                className="p-10 bg-aa-grey"
              >
                Aggregated Reporting
              </div>
              <div style={basicTierCell} className="p-10 bg-aa-grey">
                <i className="icon-checkmark4 text-teal-400 " />
              </div>
              <div
                style={{ width: "34%", textAlign: "center" }}
                className="p-10 bg-aa-grey"
              >
                <i className="icon-checkmark4 text-teal-400 " />
              </div>
              <div
                style={{ width: "40%", fontWeight: "bold" }}
                className="p-10"
              >
                Detailed Reporting
              </div>
              <div style={basicTierCell} className="p-10">
                <i className="icon-checkmark4 text-teal-400 " />
              </div>
              <div
                style={{ width: "34%", textAlign: "center" }}
                className="p-10"
              >
                <i className="icon-checkmark4 text-teal-400 " />
              </div>
            </div>
          </div>
          <div style={{ ...tableBodyRow, padding: "0" }}>
            <div style={rowFirstCell}>
              <div style={{ marginTop: "130px" }}>Insights</div>
            </div>
            <div
              style={{ width: "85%", display: "inline-flex", flexWrap: "wrap" }}
            >
              <div
                style={{ width: "40%", fontWeight: "bold" }}
                className="p-10 bg-aa-grey"
              >
                Dashboard View
              </div>
              <div style={basicTierCell} className="p-10 bg-aa-grey">
                <i className="icon-checkmark4 text-teal-400 " />
              </div>
              <div
                style={{ width: "34%", textAlign: "center" }}
                className="p-10 bg-aa-grey"
              >
                <i className="icon-checkmark4 text-teal-400 " />
              </div>
              <div
                style={{ width: "40%", fontWeight: "bold" }}
                className="p-10"
              >
                Top Attributes
              </div>
              <div style={basicTierCell} className="p-10">
                <i className="icon-checkmark4 text-teal-400 " />
              </div>
              <div
                style={{ width: "34%", textAlign: "center" }}
                className="p-10"
              >
                <i className="icon-checkmark4 text-teal-400 " />
              </div>
              <div
                style={{ width: "40%", fontWeight: "bold" }}
                className="p-10 bg-aa-grey"
              >
                Detailed Attributes
              </div>
              <div style={basicTierCell} className="p-10 bg-aa-grey" />
              <div
                style={{ width: "34%", textAlign: "center" }}
                className="p-10 bg-aa-grey"
              >
                <i className="icon-checkmark4 text-teal-400 " />
              </div>
              <div
                style={{ width: "40%", fontWeight: "bold" }}
                className="p-10"
              >
                Top 20 Businesses
              </div>
              <div style={basicTierCell} className="p-10" />
              <div
                style={{ width: "34%", textAlign: "center" }}
                className="p-10"
              >
                <i className="icon-checkmark4 text-teal-400 " />
              </div>
              <div
                style={{ width: "40%", fontWeight: "bold" }}
                className="p-10 bg-aa-grey"
              >
                Custom Variables
              </div>
              <div style={basicTierCell} className="p-10 bg-aa-grey" />
              <div
                style={{ width: "34%", textAlign: "center" }}
                className="p-10 bg-aa-grey"
              >
                <i className="icon-checkmark4 text-teal-400 " />
              </div>
              <div
                style={{ width: "40%", fontWeight: "bold" }}
                className="p-10"
              >
                Page Level Detail
              </div>
              <div style={basicTierCell} className="p-10" />
              <div
                style={{ width: "34%", textAlign: "center" }}
                className="p-10"
              >
                <i className="icon-checkmark4 text-teal-400 " />
              </div>
              <div
                style={{ width: "40%", fontWeight: "bold" }}
                className="p-10 bg-aa-grey pt-20"
              >
                File Output
              </div>
              <div style={basicTierCell} className="p-10 bg-aa-grey" />
              <div
                style={{ width: "34%", textAlign: "center" }}
                className="p-10 bg-aa-grey"
              >
                500 Consumers Records
                <br />
                200 Businesses Records
              </div>
            </div>
          </div>
        </Dialog>
        <h5
          className="no-margin-top no-margin-bottom"
          style={{ fontWeight: "bold", fontSize: "24px" }}
        >
          Current Release Notes
        </h5>
        <Row
          className="no-margin-bottom no-margin-top no-padding-left no-padding-bottom light-grey-bottom-border"
          style={{ paddingTop: "15px", margin: 0, paddingRight: 0 }}
        >
          <Col
            xs="12"
            sm="12"
            md="12"
            lg="12"
            style={{ fontWeight: "350", paddingLeft: "5px", paddingRight: 0 }}
          >
            <div
                className="mb-10"
                style={{
                  height: this.state.collapsed === true ? "168px" : "auto",
                  overflow: this.state.collapsed === true ? "hidden" : "auto",
                }}
            >
              <div className="line">
                <strong>Release Notes 4/10/25</strong>
                <div className="mb-10 mt-10">Audience Builder Update:</div>
                <ul style={{margin: "0px"}}>
                  <li>
                    The Audience module has been updated with new options for Audience building. Users can select from
                    geographic, demographic and lifestyle options to define a desired audience. Count estimates are
                    provided for direct mail, email, social and display campaigns.
                  </li>
                </ul>
                <div className="mb-10 mt-10">Insights Update:</div>
                <ul style={{margin: "0px"}}>
                  <li>
                    We have begun an update of the Insights module which will temporarily remove some demographic
                    descriptors that were previously visible on these pages. Key descriptors like PRIZM Premier, P$YCLE
                    Premier and ConneXions segment distributions remain available.
                  </li>
                </ul>
              </div>
              <div className="line">
                <strong>Release Notes 3/9/2020</strong>
                <div className="mb-10 mt-10">Audience Builder Update:</div>
                <ul style={{margin: "0px"}}>
                  <li>
                    Additional selections are now available in the Geography
                    category. New selections include
                    <ul>
                      <li>DMA</li>
                      <li>County</li>
                    </ul>
                  </li>
                  <li>
                    As with other geographies, the counts displayed in
                    AudienceAnywhere are for Email, Social, and Display channels
                  </li>
                </ul>
              </div>
              <div className="line">
                <strong>Release Notes 2/18/2020</strong>
                <ul style={{margin: "0px"}}>
                  <li>
                    Counts for the household matching to Zip +6 and Zip +4 have
                    been added to the Segment Distribution module.
                  </li>
                  <li>
                    The match flag enables users to better understand the
                    granularity of a zip assignment to traffic data, and present
                    a better assessment of targeting options for a digital
                    marketing campaign.
                    <ul>
                      <li>
                        Precision: Data at Z+6 will be populated for the
                        following areas
                        <ul>
                          <li>Media Channel Reach counts</li>

                          <li>
                            Segment details, device details, and CultureCodes
                          </li>

                          <li>
                            When sending an Audience of Website Visitors to the
                            Audience Builder (Pro Tier)
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>
                    At Scale: Z+6 to Z+4 fallback methodology
                    <ul>
                      <li>
                        Media Channel Reach counts in Site Analytics and Segment
                        Distribution reflect the Z+6 to Z+4 fallback methodology
                      </li>

                      <li>
                        When sending and Audience of Website Visitors to the
                        Audience Builder all matches from Z+6 and Z+4 are saved
                        to that audience.
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div className="line">
                <strong>Release Notes 1/7/2020</strong>
                <div className="mb-10 mt-10">
                  The Precision or Scale selections are now available in the
                  Insights module in the Granularity drop down.
                </div>
                <div>
                  When selecting Precision: Only data at Z+6 will be populated
                  for the following areas:
                </div>
                <ul style={{margin: "0px"}}>
                  <li>
                    Audience Reach counts in Site Analytics and Segment
                    Distribution will reflect Z+6 matches
                  </li>
                  <li>
                    Segment details, device details, and CultureCodes will only
                    display households matched at Z+6
                  </li>
                  <li>
                    When sending an Audience of Website Visitors to the Audience
                    Builder (Pro Tier) only the Z+6 matched data migrated if the
                    Precision option is selected at the time of saving the
                    audience of website visitors and visitors at scale.
                  </li>
                </ul>
                <div className="mt-10 mb-10">
                  At Scale: Z+6 to Z+4 fallback methodology
                </div>
                <ul>
                  <li>
                    Reach counts in Site Analytics and Segment Distribution
                    reflect the Z+6 to Z+4 fallback methodology
                  </li>
                  <li>
                    The Audience Builder reach counts will continue to contain a
                    mix of Individual, Z+6, and Z+4 data
                  </li>
                  <li>
                    When sending and Audience of Website Visitors to the
                    Audience Builder all matches from Z+6 and Z+4 are saved to
                    that audience.
                  </li>
                </ul>
              </div>
              <div className="line">
                <strong>Release Notes 12/15</strong>
                <div>Standard & Professional Tier:</div>
                <ul style={{margin: "0px"}}>
                  <li>
                    Introducing Precision and Scale options for the consumer
                    address records provided with your AudienceAnywhere
                    subscription
                  </li>
                  <ul>
                    <li>
                      Choose ‘Precision’ if you are interested in only receiving
                      addresses that were resolved at the Zip +6 level
                    </li>
                    <li>
                      Choose ‘Scale' to receive Zip+6 matches with a Zip+ 4
                      fall-back resolution to fulfill your account quota
                    </li>

                    <li>
                      All accounts will default to Scale, so please talk to your
                      account manager about which option is right for you
                    </li>
                  </ul>
                  <li>
                    Improvements have been made to holding selections as users
                    navigate between Insights pages. Selections made to date
                    range, measure, top segments will now be maintained until
                    changes are made or the session is ended
                  </li>
                </ul>
                <div>Audience Builder:</div>
                <ul>
                  <li>
                    Using the new tool-tip hover function in the Audience
                    Builder, users can now better understand the geo-levels for
                    every selection. Use this function to build an audience that
                    is relevant to your targeting needs.{" "}
                  </li>
                  <li>Available levels are:</li>
                  <ul>
                    <li>Individual</li>
                    <li>Household</li>
                    <li>Zip+6</li>
                    <li>Zip+4</li>
                  </ul>
                </ul>
              </div>
              <div className="line">
                <strong>Release Notes 12/3</strong>
                <div>Professional Tier:</div>
                <ul style={{margin: "0px"}}>
                  <li>
                    CultureCode data is now available in the Segment
                    Distribution dashboard for Pro Tier subscribers
                  </li>
                  <ul>
                    <li>
                      With CultureCode gain insights on anonymous website
                      visitors in the following categories:
                    </li>
                    <ul>
                      <li>Ethnicity</li>
                      <li>Region</li>
                      <li>Acculturation</li>
                    </ul>
                  </ul>
                  <li>
                    A heatmap of the traffic can now be viewed by specific top
                    segments or for the traffic on the entire domain.
                  </li>
                  <ul>
                    <li>
                      Click view on map under the Top States chart in Segment
                      Distribution
                    </li>
                  </ul>
                  <li>
                    Functionality has been added to reactivate an archived
                    audience of website visitors
                  </li>
                  <ul>
                    <li>
                      Audiences created from website visitors will automatically
                      be archived 90 days after they are created
                    </li>
                  </ul>
                </ul>
                <strong>Release Notes 11/15</strong>
                <ul style={{margin: "0px"}}>
                  <li>Professional Tier</li>
                  <ul>
                    <li>
                      Save an audience from actual website visitors for further
                      refinement in the Audience Builder module
                    </li>
                    <li>
                      Users can now target website visitors or their preferred
                      segments at scale using the Create Audience button in the
                      Insights Segmentation Distribution module
                    </li>
                  </ul>
                  <li>Site Analytics</li>
                  <ul>
                    <li>
                      A left rail has been introduced on the main site analytics
                      page with individual tabs for Total, Consumer, and
                      Business
                    </li>
                    <li>
                      The Total tab allows users to better understand all
                      traffic identified by the pixel fire
                    </li>
                    <ul>
                      <li>
                        Total traffic is the combination of Consumer, Business,
                        and Other non-routable traffic
                      </li>
                      <li>
                        The Other category includes: Proxy, Wireless, Foreign,
                        and Bot traffic
                      </li>
                    </ul>
                  </ul>
                </ul>
              </div>
              <div className="line">
                <strong>Release Notes 10/31</strong>
                <ul style={{margin: "0px"}}>
                  <li>
                    PDF Report downloads are now available for the following
                    Site Analytics Consumer Pages
                  </li>
                  <ul>
                    <li>Overview Page</li>
                    <li>Demographics</li>
                    <li>Devices</li>
                    <li>Most Popular Pages Report</li>
                  </ul>
                </ul>
              </div>
              <div className="line">
                <strong>Release Notes 10/18 </strong>
                <ul style={{margin: "0px"}}>
                  <li>
                    The Insights Site Analytics pages are updated with a new
                    user interface and additional functionality
                  </li>

                  <ul>
                    <li>
                      A left rail has been introduced in Site Analytics to allow
                      users to quickly understand insights about both Consumer
                      and Business traffic
                    </li>
                    <li>
                      View up to the top 100 Popular Pages for both Consumer and
                      Business Traffic
                    </li>
                  </ul>
                  <li>
                    The Audience Builder now features a “Target Households Only”
                    button allowing for reach numbers to be calculated in real
                    time for the Household records.
                  </li>
                  <ul>
                    <li>
                      Leave this button unchecked if targeting at scale and want
                      to market to the maximum audience that the system can
                      provide
                    </li>
                  </ul>
                </ul>
                <div className="mt-10 mb-10">
                  <strong>Q3 Release Updates</strong>
                </div>
                <strong>Segment Distribution Module</strong>
                <ul>
                  <li>
                    View visitors for specific pages through the lens of
                    Claritas Syndicated Segmentation
                  </li>
                  <ul>
                    <li>
                      The 100 most popular pages can now be viewed in the
                      Insights Dashboard
                    </li>
                    <li>
                      This functionality was previously only available at the
                      domain level
                    </li>
                  </ul>
                  <li>
                    Add up to 20 Favorite Pages to track and view in the
                    Insights Dashboard
                  </li>
                  <ul>
                    <li>
                      View favorite pages through the lens of Claritas
                      Syndicated Segmentation
                    </li>
                    <li>The list of 20 pages can be edited at any time</li>
                    <li>
                      Easily add popular pages to your favorites list by
                      clicking the star from the popular pages view
                    </li>
                    <li>
                      Search and add any page from your domain to your favorites
                      list
                    </li>
                  </ul>
                  <li>
                    Choose up to 10 top segments or select ‘All’ to view
                    insights about all site visitors and download the data as a
                    PDF or CSV
                  </li>
                  <ul>
                    <li>
                      Top segments can be viewed either as an Index or % of
                      Household Visitors
                    </li>
                  </ul>
                  <li>
                    Choose up to 10 top segments or select ‘All’ to view
                    insights about all visitors to the domain
                  </li>
                  <li>
                    Introducing the ability to choose the measure by which you
                    view anonymous traffic. The new ‘Measure’ drop-down enables
                    users to select:
                  </li>
                  <ul>
                    <li>% of Household Visitors</li>
                    <li>Index</li>
                    <ul>
                      <li>
                        The Index measure helps client hone-in on their best
                        audience by comparing the % of Household Visitors from a
                        given segment to the Claritas data on the % of the total
                        U.S population that the segment represents.
                      </li>
                    </ul>
                  </ul>
                </ul>
                <strong>Consumer Address File</strong>
                <ul>
                  <li>
                    Top segments by the measure and Claritas Syndicated
                    Segmentation system of your choice can now inform the
                    Consumer Address File download for Professional Tier
                    subscribers
                  </li>
                  <ul>
                    <li>
                      For example, the 500 default records can now be derived
                      from the top number of PRIZM Premier segments that the
                      user selects. The system will only provide addresses from
                      the top segments until the quota on the account is
                      reached.
                    </li>
                    <li>
                      Talk to your account manager about increasing the amount
                      of records available on your profile
                    </li>
                    <li>
                      Standard tier functionality remains the same where the 500
                      records will be pulled at random from the site traffic
                    </li>
                  </ul>
                  <li>
                    The consumer address file download has been updated to
                    provide only the Primary Decision Maker (PDM) record for the
                    household on file. This update allows the user to maximize
                    the number of addresses received in their specified quota.
                  </li>
                </ul>
                <strong>Audience Builder</strong>
                <ul>
                  <li>
                    Geoscape CultureCodes data is now available in the Audience
                    Builder Module
                  </li>
                  <li>Refine your audience by</li>
                  <ul>
                    <li>Ethnicity</li>
                    <li>Region & Locale</li>
                    <li>Acculturation</li>
                    <li>Language Segments</li>
                  </ul>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
        <div className="read-more-container">
          <a
              className="aa-color"
              href="#"
              onClick={this.clickReadMore.bind(this)}
          >
            {this.state.collapsed === true ? "...Read more" : "...Show less"}
          </a>
        </div>
      </div>
    );
  }
}

export default ReleaseNote;



// WEBPACK FOOTER //
// ./src/components/Dashboard/release-note.jsx